// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page {
  min-height: calc(100vh - 48px);
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
}

.card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 40px 48px;
  max-width: 520px;
  width: 100%;
  text-align: center;
}

.icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--theme-main-color, #055C8D);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.icon-wrap i {
  font-size: 28px;
  color: #FFFFFF;
}

h1 {
  font-size: 22px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 12px;
}

p {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}

.divider {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 28px 0;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--theme-main-color, #055C8D);
  color: #FFFFFF;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 6px;
  margin-bottom: 20px;
}

.badge i {
  font-size: 14px;
}

.admin-section p {
  font-size: 13px;
  color: #999;
  margin-bottom: 16px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
